import { StyleSheet, Text, View } from 'react-native';

import { colorSemantic, spacing } from '@/theme';

export interface CharacterCounterProps {
  readonly count: number;
  readonly max: number;
  readonly prefix?: string;
  readonly testID?: string;
}

export const CharacterCounter = ({ count, max, prefix = '', testID }: CharacterCounterProps) => {
  const label = `${prefix}${count}/${max}`;

  return (
    <View accessibilityLabel={label} style={styles.container} testID={testID}>
      <Text style={styles.label}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: colorSemantic.colorBgNlBase,
    borderColor: colorSemantic.colorBorderNdBase,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: spacing[4],
    paddingVertical: spacing[2],
  },
  label: {
    color: colorSemantic.colorTextNdPrimary,
    fontSize: 16,
    letterSpacing: 0.5,
    lineHeight: 24,
  },
});
